import { render, staticRenderFns } from "./BagsList.vue?vue&type=template&id=078359a6"
import script from "./BagsList.vue?vue&type=script&lang=js"
export * from "./BagsList.vue?vue&type=script&lang=js"
import style0 from "./BagsList.vue?vue&type=style&index=0&id=078359a6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports